const typographyModalAction = {
  text: 'ATTACH FILES',
  true: 'Register New Action',
  false: 'Edit Action'
};

export default typographyModalAction;
